import styled from "styled-components"

export const GaugeWrap = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  height: ${({ width }) => width}px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  user-select: none;
  position: relative;
`

export const PredictionConfidence = styled.div`
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  font-size: 1rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  > span {
    font-size: 1rem;
  }
`

export const IconWrap = styled.div<{
  size: number
  color: string
}>`
  position: absolute;
  top: 62.5%;
  padding: 0.25rem;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  min-width: ${({ size }) => size}px;
  min-height: ${({ size }) => size}px;

  border: ${({ color }) => `1px solid ${color}`};
  border-radius: 50px;
  transition: all 0.6s ease;
`

export const LabelRow = styled.div<{
  width: string | number
  height: string | number
}>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  min-width: ${({ width }) => width}px;
  min-height: ${({ height }) => height}px;
  text-align: center;

  position: absolute;
  bottom: 0;
`

export const ValueWrap = styled.span<{
  width: number
}>`
  width: ${({ width }) => width}px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: baseline;
`
